import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {goToNextPageAsync} from '../../ServiceAppointmentAsyncthunk';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import exclamationMark from '../../images/exclamationMark.svg';
import yellowMark from '../../images/yellow_exclamation_mark.svg';
import successIcon from '../../images/success_icon.svg';

const MessagePage = (props) => {
  let title = null;
  let subTitle = null;
  let icon = 'error-icon';
  let isDisplayWhatsAppIcon = false;
  let btnText = 'בואו נתקדם';
  let isWhiteBtn = false;
  let image = '';
  let isMessageExplanation = '';
  let isDisplayMes = false;
  let imageEpi = '';

  const imageRouter = props.routerDisplay?.map((item) => item?.desImage.src);

    switch (props.typePage) {
        case 'PERFORMING_INTERNET_TEST_PAGE_1_1_1_1':
            imageEpi = imageRouter[0];
            title='נעשה בדיקה לאינטרנט שלך';
            subTitle= <>לפני תחילת הבדיקה יש לוודא שנורת ה-power של הנתב דולקת בירוק קבוע<br></br></>;
            isMessageExplanation = <> התהליך אורך מספר דקות וכולל איתחול נתב ובדיקות <br></br>נוספות שיגרמו לניתוק התקשורת זמני בכל המכשירים<br></br> המחוברים לאינטרנט בכבל או ב Wi-Fi.</>
            btnText='התחלת הבדיקה'
            break;
        case 'RESTARTING_THE_ROUTER_8_1':
            imageEpi = imageRouter[0];
            title='כדי להמשיך בבדיקה, בשלב זה נבצע הפעלה מחדש של הנתב';
            subTitle= <>ההפעלה מחדש תתבצע בצורה אוטומטית מרחוק, <br></br>אין צורך לכבות פיזית את הנתב</>;
            isDisplayMes = true;
            btnText='המשך'
            break;
        case 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4':
            imageEpi = imageRouter[0];
            title='נראה שההפעלה מחדש האוטומטית לא עזרה, יש להפעיל מחדש ידנית';
            subTitle= 'יש לכבות את הנתב ולהפעילו מחדש, ולאחר מכן להמתין 120 שניות.';
            isDisplayMes = true;
            btnText='המשך'
            break;
        case 'RESTART_NO_CELLCOM_8_2':
            imageEpi = imageRouter[0];
            title='יש לבצע הפעלה מחדש';
            subTitle= 'יש לכבות את הנתב ולהפעילו מחדש, ולאחר מכן להמתין 120 שניות.';
            isDisplayMes = true;
            btnText='כיביתי והפעלתי מחדש את הנתב'
            break;
        case 'RECEIVED_11_1_1':
            image = successIcon;
            title='קיבלנו, אנחנו על זה';
            subTitle = props.callBackSubTitle;
            btnText='חזרה לאיזור האישי';
            isWhiteBtn = true;
            break;
        case 'HAPPY_TO_HELP':
            image = successIcon;
            title = 'נהדר שמחנו לעזור!';
            btnText = 'חזרה לאיזור האישי';
            isWhiteBtn = true;
            break;
    };

  function handleOnContinue() {
    props.goToNextPageAsync();
  }

  return (
    <div className='message-page page-wrapper page-wrapper'>
      <div className='content'>
        <div className='message-icon'>
          {imageEpi && <Image src={imageEpi} alt={'image'} />}
          {image && <Image src={image} alt={'image'} />}
        </div>
        {title && <div className='page-title'> {title} </div>}
        {subTitle && <div className='page-sub-title'> {subTitle} </div>}
        {isMessageExplanation && <div className='message-explanation'> {isMessageExplanation} </div>}

        {isDisplayMes && (
          <div className='message-wrapper'>
            <Image src={yellowMark} alt='yellowMark' />
            <div className='message-text'>
              {' '}
              הפעלה מחדש תגרום לניתוק זמני של האינטרנט הביתי. חשוב להתחבר לרשת סלולרית או ל-Hotspot לפני ההמשך.
            </div>
          </div>
        )}
      </div>

      <div className='button-wrapper'>
        <BtnSubmit className={isWhiteBtn ? 'white-btn' : ''} isBusiness={false} text={btnText} onclick={handleOnContinue} formid='error-page' isDisplayArrows={false} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    typePage: state.serviceAppointmentSchedulerBlock.typePage,
    routerDisplay: state.serviceAppointmentSchedulerBlock.routerDisplay,
    callBackSubTitle: state.serviceAppointmentSchedulerBlock.dataEpi.subInfo,
  };
};

const mapDispatchToProps = {goToNextPageAsync};

export default connect(mapStateToProps, mapDispatchToProps)(MessagePage);
